import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";

const renderMergedProps = (component, props, ...rest) => {
  const finalProps = Object.assign({}, props, ...rest);
  return React.createElement(component, finalProps);
};

const PrivateRoute = ({ component, authenticated, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (authenticated) {
        return renderMergedProps(component, props, rest);
      }

      // store current location for post-login redirect
      sessionStorage.setItem(
        "post_login_redirect",
        (props.location ? props.location.pathname : window.location.pathname) +
          (props.location ? props.location.search : window.location.search)
      );

      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

const { object, bool, string, func } = PropTypes;

PrivateRoute.propTypes = {
  component: func.isRequired,
  exact: bool,
  path: string.isRequired,
  authenticated: bool.isRequired,
  location: object,
};

export default withRouter(connect()(PrivateRoute));
